import { BRAND } from "@/data/products";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  const msg = encodeURIComponent(
    "Hello Vardaan Arts, I saw your website and would like to enquire about a custom marble piece."
  );
  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 px-5 py-4 bg-[#25D366] text-white shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 group"
      style={{ boxShadow: "0 10px 30px rgba(37,211,102,0.35)" }}
    >
      <MessageCircle className="w-6 h-6 fill-white" />
      <span className="hidden sm:inline text-sm font-medium tracking-wide">
        Chat with us
      </span>
      <span className="absolute -top-2 -right-2 flex h-4 w-4">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-4 w-4 bg-white"></span>
      </span>
    </a>
  );
}
